import { Link } from "react-router-dom";
import { Ruler, HelpCircle, ArrowRight } from "lucide-react";
import { useServices, useProblems } from "../i18n/content";
import { useLp } from "../i18n/lang";
import { useCopy } from "../i18n/copy";

export const NeedSelector = () => {
  const services = useServices();
  const problems = useProblems();
  const c = useCopy("need");
  const cm = useCopy("common");
  const lp = useLp();
  return (
    <section className="section-gap" data-testid="need-selector-container">
      <div className="container-site">
        <p className="tech-label mb-4">{c.kicker}</p>
        <div className="grid lg:grid-cols-2 gap-px bg-slate-200 border hairline">
          <div className="bg-paper p-8 sm:p-12">
            <Ruler size={26} className="text-cadastral" aria-hidden="true" />
            <h3 className="mt-5 text-xl sm:text-2xl font-semibold text-ink">{c.knowT}</h3>
            <p className="mt-3 text-slate-600 text-[15px] leading-relaxed">{c.knowText}</p>
            <ul className="mt-6 space-y-2.5">
              {services.slice(0, 5).map((s) => (
                <li key={s.slug}>
                  <Link to={lp(`/servicios/${s.slug}/`)} className="group flex items-center justify-between text-[15px] text-ink/85 hover:text-terracotta transition-colors">
                    {s.shortName}
                    <ArrowRight size={14} className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" aria-hidden="true" />
                  </Link>
                </li>
              ))}
            </ul>
            <Link to={lp("/servicios/")} className="mt-6 inline-block text-sm font-bold text-cadastral link-underline" data-testid="need-selector-all-services">
              {cm.allServices}
            </Link>
          </div>
          <div className="bg-obsidian p-8 sm:p-12 text-paper">
            <HelpCircle size={26} className="text-terracotta" aria-hidden="true" />
            <h3 className="mt-5 text-xl sm:text-2xl font-semibold">{c.probT}</h3>
            <p className="mt-3 text-slate-300 text-[15px] leading-relaxed">{c.probText}</p>
            <ul className="mt-6 space-y-2.5">
              {problems.slice(0, 5).map((p) => (
                <li key={p.slug}>
                  <Link to={lp(`/problemas/${p.slug}/`)} className="group flex items-center justify-between text-[15px] text-slate-200 hover:text-terracotta transition-colors">
                    {p.shortName}
                    <ArrowRight size={14} className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" aria-hidden="true" />
                  </Link>
                </li>
              ))}
            </ul>
            <Link
              to={lp(`/contacto/?necesidad=${encodeURIComponent(cm.unclearNeed)}`)}
              data-testid="need-selector-tell-case"
              className="mt-6 inline-block text-sm font-bold text-terracotta underline decoration-terracotta/40 underline-offset-4 hover:decoration-terracotta"
            >
              {c.probLink}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
